/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../config/https";
import Header from "../layout/header";
import Swipercard from "./Swiper";
import { toast } from "react-toastify";
const Detail = () => {
  const { id } = useParams("");
  const navigate = useNavigate("");
  const [users, setUsers] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const openLightbox = (index) => {
    setIsOpen(true);
    setPhotoIndex(index);
  };
  const Searchuser = () => {
    setLoader(true);
    axiosInstance
      .get(`users/${id}`)
      .then((response) => {
        if (response.data.status === true) {
          if (response.data.data === null) {
            navigate("/");
            toast.error("No Data found");
          } else {
            setUsers(response?.data?.data);
          }
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  useEffect(() => {
    Searchuser();
  }, [id]);

  return (
    <>
      {loader ? <div className="loader" /> : null}
      <Header />
      <div style={{ background: " #F6F8FC" }}>
        <div className="container" style={{ maxWidth: "85%" }}>
          <div className="row p-3 ">
            <div className="col-md-3 col-sm-3">
              <Link className="btn btn-primary" to={"/"}>
                Back
              </Link>
            </div>
            <div className="col-md-6 col-md-6">
              <h3 className="text-center">{id}</h3>
            </div>
          </div>
          <div className=" p-3 mt-3">
            <div id="gallery" className="container-fluid">
              {users?.images.length > 0 && users?.images?.map((e, i) => < img
                src={e.image}
                className="img-responsive"
                alt={users?.fname}
                onClick={() => openLightbox(i)}
              />)
              }
            </div>

          </div>
          {isOpen && (
            <Lightbox
              mainSrc={users?.images[photoIndex].image}
              nextSrc={
                users?.images[(photoIndex + 1) % users?.images.length].image
              }
              prevSrc={
                users?.images[
                  (photoIndex + users?.images.length - 1) % users?.images.length
                ].image
              }
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex(
                  (photoIndex + users?.images.length - 1) % users?.images.length
                )
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % users?.images.length)
              }
            />
          )}
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className="card shadow-lg p-3 mt-3">
                    <h4 className="detail-title mt-2 mb-3">Item Stamping</h4>

                    <h6
                      className="detail-des"
                      dangerouslySetInnerHTML={{ __html: users?.item_stamping }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card shadow-lg p-3 mt-3">
                    <h4 className="detail-title mt-2 mb-3">
                      Item Information:
                    </h4>
                    <p className="m-0 detail-head"></p>
                    <h6
                      className="detail-des"
                      dangerouslySetInnerHTML={{
                        __html: users?.item_information,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card shadow-lg p-3 mt-3">
                <h4 className="detail-title mt-2 mb-3">Inspectors Details </h4>
                <div className="row">
                  <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Name:</p>
                    <h6 className="detail-des">
                      {users?.fname} {users?.lname}
                    </h6>
                  </div>

                  <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Email:</p>
                    <h6 className="detail-des">{users?.email}</h6>
                  </div>
                  {/* <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Phone Number:</p>
                    <h6 className="detail-des">{users?.phone}</h6>
                  </div> */}

                  <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Country:</p>
                    <h6 className="detail-des">{users?.country}</h6>
                  </div>

                  <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Inspected date:</p>
                    <h6 className="detail-des">{users?.data_inspected}</h6>
                  </div>

                  <div className="col-md-6 mb-1">
                    <p className="m-0 detail-head">Item Inspection Location:</p>
                    <h6 className="detail-des">
                      {users?.item_inspect_location}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12">
                  <div className="card shadow-lg mt-3">
                    <p className="text-center text-muted mt-3">
                      DSA 03.OME Part2 (JSP 482) Chapter 27 <br />
                      Each FFE number Correlates to the above pictures and
                      information ONLY
                    </p>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="card shadow-lg mt-3">
                    <Swipercard users={users} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Detail;
